import { render, staticRenderFns } from "./Affiliated.vue?vue&type=template&id=a172d0ae&scoped=true"
import script from "./Affiliated.vue?vue&type=script&lang=js"
export * from "./Affiliated.vue?vue&type=script&lang=js"
import style0 from "./Affiliated.vue?vue&type=style&index=0&id=a172d0ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a172d0ae",
  null
  
)

export default component.exports